<template>
  <div class="main">
    <div class="content">
      <!-- <div class="msg" v-if="stepType != 'tourist'">
        <i class="el-icon-success"></i
        >账号注册成功，您可使用创建时的手机号登录。下方完善机构信息完成机构注册吧
      </div> -->
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="query"
        label-width="125px"
      >
        <div class="account_info">账号信息</div>
        <el-form-item label="登录账号" style="margin-top: 20px">
          <p style="font-weight: 700">
            {{ phoneNumber }}
          </p>
        </el-form-item>
        <el-form-item
          label="新密码"
          style="margin-top: 20px"
          prop="newPassword"
        >
          <el-input
            v-model="query.newPassword"
            placeholder="请输入"
            style="width: 350px"
            type="password"
            @input="passwordInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" style="margin-top: 20px" prop="password">
          <el-input
            v-model="query.password"
            placeholder="请输入"
            style="width: 350px"
            @blur="passwordBlurRepeat"
            type="password"
          ></el-input>
          <div class="fontstyle">
            新密码长度8-20位，且必须包含数字、小写字母、大写字母
          </div>
          <div class="password_line">
            <span class="fontstyle" style="margin-right: 10px">密码强度</span>
            <span
              v-for="(item, index) in passwordStrength"
              :key="index"
              class="line"
              :style="{ background: item.color }"
            ></span>
            <span :style="{ color: fontStyle.color, marginLeft: '10px' }">
              {{ fontStyle.value }}
            </span>
          </div>
        </el-form-item>
        <el-form-item label="联系人姓名" style="margin-top: 20px" prop="name">
          <el-input
            v-model="query.name"
            placeholder="请输入联系人名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <div class="account_info on">机构信息</div>
        <el-form-item label="机构名称" style="margin-top: 20px" prop="orgName">
          <el-input
            v-model="query.orgName"
            placeholder="请输入机构名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构信用代码"
          style="margin-top: 20px"
          prop="orgSocialCreditCode"
        >
          <el-input
            v-model="query.orgSocialCreditCode"
            placeholder="请输入机构信用代码"
            style="width: 350px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="subbox">
        <div class="subbox_main">
          <div class="subbox_main_button">
            <el-button
              type="primary"
              size=""
              autofocus
              :disabled="!checked"
              @click="Submit()"
              >注册</el-button
            >
          </div>

          <div class="red" style="margin-top: 20px">
            <el-checkbox v-model="checked"
              >我已阅读并同意课后服务隐私协议</el-checkbox
            >
          </div>
        </div>
        <!-- <el-button
            style="margin-left: 20px; width: 120px"
            size=""
            @click="cancel()"
            >取消</el-button
          > -->
      </div>
    </div>
  </div>
</template>

<script>
import { validateIdcard } from "@/utils/validate.js";
import _ from "lodash";
import {
  handleRegister,
  handleGetCorpStatus,
  handleGetPersonStatus,
} from "@/api/register/index.js";
export default {
  props: {
    stepType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checked: false,
      fontStyle: {
        color: "",
        value: "",
      },
      passwordStrength: [
        { id: "1", color: "#f0f4f6" },
        { id: "2", color: "#f0f4f6" },
        { id: "3", color: "#f0f4f6" },
      ], //密码强度
      query: {
        orgName: "",
        orgSocialCreditCode: "",
        newPassword: "",
        password: "",
        name: "",
      },
      phoneNumber: "",
      // 宁德时代新能源科技股份有限公司  91350900587527783P
      // 黄石市芭瑞艺术培训学校有限公司  91420200MA492XG3XW
      rules: {
        orgName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        orgSocialCreditCode: [
          { required: true, message: "请输入机构信用代码", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "密码过于简单,长度8-20位!",
            trigger: "change",
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[0-9].*)/;
              console.log(passwordreg.test(value));
              if (!passwordreg.test(value)) {
                callback(new Error("密码必须包含数字、小写字母、大写字母!"));
              } else {
                callback();
              }
            },
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 8, max: 20, message: "密码长度8-20位!", trigger: "blur" },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[0-9].*)/;
              console.log(passwordreg.test(value));
              if (!passwordreg.test(value)) {
                callback(new Error("密码必须包含数字、小写字母、大写字母!"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.phoneNumber = sessionStorage.getItem("phoneNumber") || "无账号信息";
  },
  methods: {
    passwordInput(value) {
      this.query.newPassword = value;
      if (value.length > 0 && value.length <= 10) {
        this.passwordStrength = [{ id: "1", color: "#FF5050" }];
        this.fontStyle = {
          color: "#FF5050",
          value: "弱",
        };
      } else if (value.length > 10 && value.length <= 15) {
        this.passwordStrength = [
          { id: "1", color: "#4991E1" },
          { id: "2", color: "#4991E1" },
        ];
        this.fontStyle = {
          color: "#4991E1",
          value: "中",
        };
      } else if (value.length > 15 && value.length <= 20) {
        this.passwordStrength = [
          { id: "1", color: "#54D27D" },
          { id: "2", color: "#54D27D" },
          { id: "3", color: "#54D27D" },
        ];
        this.fontStyle = {
          color: "#54D27D",
          value: "强",
        };
      } else {
        this.passwordStrength = [
          { id: "1", color: "#f0f4f6" },
          { id: "2", color: "#f0f4f6" },
          { id: "3", color: "#f0f4f6" },
        ]; //密码强度
        this.fontStyle = {
          color: "",
          value: "",
        };
      }
    },
    passwordBlurRepeat() {
      if (this.query.newPassword != this.query.password) {
        this.$message({
          type: "error",
          message: "密码输入不一致",
        });
      }
    },
    Submit: _.throttle(
      async function () {
        this.getCorpStatus();
        this.$refs["rulesForm"].validate(async (valid) => {
          if (valid) {
            let params = {
              registerKey: sessionStorage.getItem("registerKey") || "", //发送验证码后返回的key
              orgName: this.query.orgName, //机构名称
              orgSocialCreditCode: this.query.orgSocialCreditCode, //组织统一社会信用代码
              password: this.query.password,
              name: this.query.name,
            };
            console.log("创建机构参数---", params);
            const { result, data, desc } = await handleRegister(params);
            console.log("创建机构成功---", data);
            if (result === "000000" && data) {
              sessionStorage.usessionId = data.usessionId;
              this.$emit("changeStep", 3);
              this.$message({
                type: "success",
                message: "注册成功",
              });
            } else {
              this.$message({
                type: "error",
                message: desc,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "请输入正确的必填项!",
            });
          }
        });
      },
      3000,
      { leading: true, trailing: false }
    ),
    //查询机构状态
    async getCorpStatus() {
      let params = {
        corpName: this.query.orgName, //机构名称
        certificateNo: this.query.orgSocialCreditCode, //组织统一社会信用代码
        // corpName: 'Test调试学校线下2-勿删', //机构名称
        // certificateNo: '52130982MJ0802624X', //组织统一社会信用代码
      };
      console.log("查询机构状态参数", params);
      sessionStorage.orgName = this.query.orgName;
      const { retCode, data, retDesc } = await handleGetCorpStatus(params);
      console.log("查询机构状态---", data);
      if (retCode === "000000" && data) {
        sessionStorage.mechanismInfo = JSON.stringify(data);
      } else {
        console.error(retDesc);
      }
    },
    cancel() {
      this.$emit("changeStep", 1);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 4%;
  .content {
    width: 650px;
    .subbox {
      margin: 8% auto;
      width: 100%;
      display: flex;
      justify-content: center;
      .subbox_main {
        margin: 0 auto;
        .subbox_main_button {
          text-align: center;
        }
      }
    }
    .account_info {
      margin-left: 10%;
      font-size: 20px;
      margin: 20px 0;
      color: #333333;
      &.on {
        // width: 800px;
        padding-top: 20px;
        border-top: 1.5px solid #eaeaea;
      }
    }
    .msg {
      margin: 0 auto;
      width: 550px;
      height: 40px;
      margin-bottom: 35px;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFang SC;
      background: #dbffe0;
      border: 1px solid #30c443;
    }
    .el-form {
      width: 550px;
      margin: 0 auto;
      .info {
        span {
          color: #4991e1;
          cursor: pointer;
        }
      }
      .fontstyle {
        font-size: 14px;
        color: #a3a4a5;
      }
      .password_line {
        display: flex;
        align-items: center;
        .line {
          display: inline-block;
          margin: 0 2px;
          width: 100px;
          height: 20px;
        }
      }
    }
  }
}

::v-deep .el-form .el-input__inner {
  // width: 450px;
  height: 40px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}
.el-icon-success {
  margin: 0 10px;
  // background: #30C443;
  color: #30c443;
}
</style>
